export class FileAssetMutable {
    constructor() {
        this.metadata = {};
    }
}
